<template>
  <div class="DetailVote">
    <div class="title">投票</div>
<!--    <detail-title-bar :data="data"/>-->
    <div :class="off ? 'content' : 'off content'">
      <div class="radio">
        <van-radio-group v-model="radio">
          <div class="radio" v-for="item in contentList">
            <div class="radio-box" v-if="item.type === 1">
              <div>
                <van-radio checked-color="#00476C" :key="item.id" :name="item.id">{{item.title}}</van-radio>
                <div class="radio-message">{{item.description}}</div>
              </div>
              <div>
                <img :src="item.image" alt="">
              </div>
            </div>
            <div v-if="item.type === 4" class="radio-title">{{item.description}}</div>
          </div>
        </van-radio-group>
      </div>
      <div v-show="!isUpdate" class="save-btn">
        <div class="save" @click="save">确认提交</div>
      </div>
      <div v-show="isUpdate" class="save-btn-2">
        <div class="save-2" @click="save">已提交</div>
      </div>
    </div>
<!--    <div v-show="!off" class="btn" @click="off = 1">更多</div>-->
<!--    <div v-show="off" class="btn" @click="off = 0">收起</div>-->
  </div>
</template>

<script>
import DetailTitleBar from "@/views/meetings/detail/DetailTitleBar";

export default {
  name: "DetailVote",
  components: {DetailTitleBar},
  props: {
    voteList: {
      type: Array,
      default: () => ([])
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isUpdate: false,
      contentList: [],
      off: 1,
      radio: null
    }
  },
  mounted() {
    this.voteGet()
    this.getUserVote()
  },
  methods: {
    save() {
      if (!this.radio) {
        this.$notify('您还没有勾选投票选项')
        return
      }
      let activityId = this.$route.params.id
      let userId = localStorage.getItem('userId-school')
      let name = ''
      this.contentList.forEach(item => {
        if(item.id === this.radio) {
          name = item.title
        }
      })
      let params = {
        userid: userId,
        name: name,
        voteid: this.radio
      }
      this.$http.post(this.$api.vote.save + `${activityId}/${userId}`, params).then(res => {
        let {code, message} = res
        if (code === 0) {
          this.$toast('提交成功')
          this.voteGet()
          this.getUserVote()
        } else {
          this.$toast(message)
        }
      }).catch(err => {
        this.$toast(err.message)
      })
    },
    getUserVote() {
      let id = this.$route.params.id
      let userIid = localStorage.getItem('userId-school')
      this.$http.get(this.$api.vote.getUser + `${id}/${userIid}`).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          if (data) {
            this.radio = data[0].voteid
            this.isUpdate = true
          }
        } else {
          this.$toast(message)
        }
      })
    },
    voteGet() {
      this.$http.get(this.$api.vote.list + this.$route.params.id).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          this.contentList = data
        } else {
          this.$toast(message)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.radio {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 20px 0;
}
.radio-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 174px;
    height: 98px;
    border-radius: 10px;
  }
  div:nth-child(2) {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
}
::v-deep {
  .van-radio, .van-checkbox {
    margin-top: 10px;
    font-size: 14px;
  }
}

.DetailVote {
  border-bottom: 1px solid #ECECEC;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 25px;
  margin-top: 20px;

  .off {
    height: 150px;
    overflow: hidden;
  }

  .btn {
    background: #ECECEC;
    width: 80px;
    height: 50px;
    font-size: 22px;
    color: #00476C;
    text-align: center;
    line-height: 50px;
    position: absolute;
    right: 25px;
    bottom: 10px;
  }

  .save-btn {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;

    .save {
      border-radius: 40px;
      width: 393px;
      height: 74px;
      background: #0091C5;
      color: #FFFFFF;
      font-size: 34px;
      line-height: 74px;
      font-weight: bold;
    }
  }

  .save-btn-2 {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;

    .save-2 {
      border-radius: 40px;
      width: 393px;
      height: 74px;
      background: #ECECEC;
      color: #D2D2D2;
      font-size: 34px;
      line-height: 74px;
      font-weight: bold;
    }
  }

  .radio-message {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 50px;
    margin-top: 10px;
    font-size: 12px;
    color: #999999;
    text-align: left;
  }

  .radio-title {
    font-size: 30px;
    color: #00476C;
    text-align: left;
    margin-top: 30px;
  }

  .message {
    color: #333333;
    font-size: 28px;
    text-align: left;
    margin-top: 30px;
  }

  .title {
    text-align: left;
    font-size: 34px;
    color: #00476C;
    font-weight: 600;
  }
}
</style>
